import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        background: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    header: css({
        display: 'flex',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        width: '100%',
        height: '70px',
        background: theme.palette.common.white,
        paddingRight: '20px',
        alignItems: 'center',
    }),
    drawer: {
        height: '95vh',
        borderTopLeftRadius: '15px',
        borderTopRightRadius: '15px',
    },
    modal: css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxHeight: '90vh',
        maxWidth: '90vw',
        overflowY: 'auto',
        ':focus': {
            outline: 'none',
        },
    }),
    payment: css({
        width: '100%',
    }),
    closeIcon: css({
        position: 'absolute',
        right: '20px',
        top: '19px',
        cursor: 'pointer',
        [theme.breakpoints.up('lg')]: {
            right: '50px',
            top: '19px',
        },
    }),
    contentWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        paddingInline: '20px',
        [theme.breakpoints.up('lg')]: {
            width: '570px',
        },
    }),
    bgGray: css({
        width: '100%',
        paddingTop: '50px',
        background: isHosTheme ? theme.palette.common.white : theme.palette.background.paper,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    details: css({
        border: isHosTheme ? `0.5px solid ${theme.palette.secondary.dark}` : 'none',
        padding: isHosTheme ? '30px 20px' : '0 0 50px 0',
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
        }),
        [theme.breakpoints.down('lg')]: {
            border: 'none',
            padding: '20px 0 0 0',
        },
    }),
    cta: css({
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'center',
        margin: '30px 0 40px 0',
        order: 1,
        [theme.breakpoints.up('lg')]: {
            order: 2,
            width: '190px',
        },
    }),
};
